import { Trash2, X } from 'lucide-react';
import React from 'react';

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  itemName?: string;
  pageTitle?: string;
  fromItem?: string;
  assignedProjects?: string[];
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  onDelete,
  itemName,
  pageTitle,
  fromItem,
  assignedProjects = [],
}) => {
  if (!isOpen) return null;

  // const hasProjects = assignedProjects?.length > 0;
  return (
    <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-50">
      <div
        className="absolute left-[255px] top-[72px] right-0 bottom-0 pointer-events-auto flex items-center justify-center"
        style={{
          background:
            'linear-gradient(174.07deg, rgba(173, 12, 98, 0.85) 0.38%, rgba(98, 28, 67, 0.85) 95.87%)',
        }}
      >
        <div className="bg-[#621C43] rounded-lg shadow-lg p-6 w-[400px] text-center">
          {/* Header */}
          <div className="flex justify-between items-center mb-3">
            <div className="flex items-center gap-3">
              <div className="bg-[#FFFFFF4D] p-2 rounded-full flex items-center justify-center">
                <Trash2 className="h-5 w-5 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-[#FFF8ED]">Delete {pageTitle}</h3>
            </div>

            <button onClick={onClose} className="p-2 rounded-full hover:bg-[#FFFFFF33] transition">
              <X className="h-5 w-5 text-white" />
            </button>
          </div>

          <div className="border-t border-[#FFF8ED]/30 my-4"></div>

          {/* Content */}
          <p className="text-[#E2E2E2E5] text-lg mb-6">
            {fromItem ? (
              <>
                Are you sure you want to remove <br />
                <span className="font-semibold text-[#FFF8ED] text-lg">
                  {itemName || 'selected item'}
                </span>
                <br />
                from <span className="font-semibold text-[#FFF8ED] text-lg">{fromItem}?</span>
              </>
            ) : (
              <>
                Are you sure, you want to delete <br />
                <span className="font-semibold text-[#FFF8ED] text-lg">
                  {itemName || 'selected item'}?
                </span>
              </>
            )}
          </p>

          {/* Warning Box — Show only if assignedProjects exist */}
          {assignedProjects && assignedProjects.length > 0 && (
            <div className="bg-[#FFF39452]/20 border border-[#FFF8ED]/40 text-[#FFF8ED] p-3 rounded-lg mb-5 flex items-start gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 mt-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M12 9v3m0 4h.01M10.29 3.86L1.82 18a1 1 0 00.86 1.5h18.64a1 1 0 00.86-1.5L13.71 3.86a1 1 0 00-1.72 0z"
                />
              </svg>

              <p className="text-sm">
                This admin is currently assigned to <b>{assignedProjects[0]}</b>
                {assignedProjects.length > 1 && ` and ${assignedProjects.length - 1} more`}. Please
                re-assign ownership before deleting.
              </p>
            </div>
          )}

          {/* Buttons */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 text-sm rounded-md text-[#1A0206] bg-[#B0B0AF] hover:bg-[#d0cfcf]"
            >
              Cancel
            </button>
            <button
              onClick={onDelete}
              // disabled={hasProjects}
              className={`flex-1 px-4 py-2 text-sm rounded-md bg-[#FF383C] hover:bg-[#e22e32] text-[#FFF8ED]"
              `}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
